import { useEffect, useState } from 'react';
import { cacheMinimal, clearRequest, ErrorMessage, errorReceived, formData, readMinimalCache, responseData, setErrorReceived, setLicenseCountry, setLicenseNumber, setLicenseState, setQueryType, getErrorMessage } from '../../utils/data';
import { Link, useNavigate } from 'react-router-dom';
import PrintPage from '../PrintPage';
import Loading from '../Loading';
import { useAuth } from '../../context/AuthContext';
import { createLog } from '../datawriter/createLog';
import { saveList, getList, stateList } from './util/stateList';
import "../print.css"
import moment from 'moment';

function MinimalResponse() {
    // const testData = api.MinimalResponse;
    const [testData, setTestData] = useState({});
    const [states, setStates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [requestID, setRequestID ]= useState();
    const [errorMessage, setErrorMessage] = useState([]);
    const navigate = useNavigate();
    const { token, email } = useAuth();
    const defined = (v) => v !== undefined && v !== null && v !== "";

    const minimalKey = `/${formData.Body.DriverRequest.DriverData.DriverName.DriverLastName}`;
    //console.log("FS: "+JSON.stringify(formData.Body.DriverRequest.DriverLicense.LicenseState));
 useEffect(() => {
        const fetchData = async () => {
            const cached = readMinimalCache(minimalKey);
            if (cached) {
                console.log("Cached response found:", cached);
                setErrorMessage(cached.messages);
                setTestData(cached.response);
                setStates(cached.request);
                setRequestID(cached.transactionID);
                setLoading(false);
                return;
            }
          try {
            await responseData('/api/minimal', token)
            .then(function (response) {
                createLog(response, email);
                if(response?.Response?.DriverDetails !== undefined) {
                    setErrorMessage(response.Messages);
                    setTestData(response);
                    setStates(response?.RequestKey?.Body?.DriverRequest?.DriverLicense?.LicenseState || []);
                    console.log("Completed:",response);
                    setRequestID(response.TransactionGUID);
                    cacheMinimal({ key: minimalKey, response });
                    setLoading(false);
                } else {
                    setErrorReceived(response.Messages.length > 0 ? response.Messages : ["Database Unavailable"]);
                    navigate(-1);
                }
            })
            .catch(  (error) => {
                console.error(error);
                setErrorReceived([getErrorMessage(error, 'No matching record was found. Please try again.')]);
                navigate(-1);
            })
            
          } catch (error) {
            console.error('caught error: ', error);
            setErrorReceived([getErrorMessage(error, 'No matching record was found. Please try again.')]);
            navigate(-1);
          }
          
        };
    
        fetchData();
    }, []);
    
    function navHistory(e, license, state) {
        e.preventDefault();
        setLicenseCountry("US");
        setLicenseNumber(license);
        setLicenseState(state.toUpperCase());
        navigate('/historyresults', { state: { fromAkaMinimal: true, licenseOnly: true } })
    }
    if(loading){
        return(<>
            <Loading />
            </>)
    }

    let newList = [];
    let stateList = [];
    if(!defined(stateList)){
        stateList = [
        "AK", "AL", "AR", "AZ", "CA" , "CO", "CT", "DC", "DE", "FL", "GA", "HI", "IA", 
        "ID", "IL", "IN", "KS", "KY",  "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", 
        "MT",  "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA",
        "RI", "SC",  "SD", "TN", "TX", "UT", "VA", "VT", "WA", "WI",  "WV", "WY"  ]
        
    } else {
        stateList = formData.Body.DriverRequest.DriverLicense.LicenseState;
    }

    console.log(JSON.stringify(formData))

    if(Array.isArray(states) === true){
        if(states.length > 0){
            states.map((v) => {
                testData.Response.DriverDetails.map((details) => {
                    if(v === details.License.JurisdictionOfIssue){
                        const temp = {
                            "LicenseNumber" :  details.License.LicenseNumber,
                            "JurisdictionOfIssue" : details.License.JurisdictionOfIssue,
                            "FirstName" : details.PersonDetails.PersonName.FirstName,
                            "MiddleName" : details.PersonDetails.PersonName.MiddleName,
                            "SurName" : details.PersonDetails.PersonName.SurName,
                            "DOB" : details.PersonDetails.DOB
                        }
                        newList.push(temp)
                    }
                })
            })
        }
        else{
            testData.Response.DriverDetails.map((details) => {
            const temp = {
                "LicenseNumber" :  details.License.LicenseNumber,
                "JurisdictionOfIssue" : details.License.JurisdictionOfIssue,
                "FirstName" : details.PersonDetails.PersonName.FirstName,
                "MiddleName" : details.PersonDetails.PersonName.MiddleName,
                "SurName" : details.PersonDetails.PersonName.SurName,
                "DOB" : details.PersonDetails.DOB
            }
            newList.push(temp)
        })
        }
    } else {
        testData.Response.DriverDetails.map((details) => {
                    const temp = {
                        "LicenseNumber" :  details.License.LicenseNumber,
                        "JurisdictionOfIssue" : details.License.JurisdictionOfIssue,
                        "FirstName" : details.PersonDetails.PersonName.FirstName,
                        "MiddleName" : details.PersonDetails.PersonName.MiddleName,
                        "SurName" : details.PersonDetails.PersonName.SurName,
                        "DOB" : details.PersonDetails.DOB
                    }
                    newList.push(temp)
                })

            
     }


    return(
        <>
        <div id='print-area'>
        {errorMessage.map((message => (
            <ErrorMessage value={message} />
        )))}
            {errorReceived.length > 0 && (
                <div className="alert alert-danger" role="alert">
                    {errorReceived.map((err, index) => (
                        <span key={index}>{err}</span>
                    ))}
                </div>
            )}
            <div id='table'>
                
            <div style={{ width: 'fit-content', background: 'white'}}>
                <div id="banner-results">
                    <table style={{width:'100%'}}>
                        <tr>
                        <td><h4>Minimal Driver Search Results</h4></td>
                
                    </tr>
                    <tr>
                        <td><h6>
                        <span style={{ marginRight: '1rem' }}>/{formData.Body.DriverRequest.DriverData.DriverName.DriverLastName}</span>
                        <span style={{float: 'right' }}>{requestID}</span>
                </h6></td>
                    </tr>
                    </table>
                    
                
                </div>
                {testData.Response.DriverDetails.length === 1 ? 
                <>
                <th>Driver General Information</th>
                <table className="table table-striped table-bordered">
                
                <thead style={{width: '100%'}}>
                    <tr>
                        <th scope="col">First Name</th>
                        <th scope="col">Middle Name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Suffix</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{testData.Response.DriverDetails[0].PersonDetails.PersonName.FirstName}</td>
                        <td>{testData.Response.DriverDetails[0].PersonDetails.PersonName.MiddleName}</td>
                        <td>{testData.Response.DriverDetails[0].PersonDetails.PersonName.SurName}</td>
                        <td>{testData.Response.DriverDetails[0].PersonDetails.PersonName.Suffix}</td>
                    </tr>
                </tbody>
            </table>
            <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col">SSN</th>
                        <th scope="col">Date of Birth</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{testData.Response.DriverDetails[0].PersonDetails.SSN}</td>
                        <td>{moment(testData.Response.DriverDetails[0].PersonDetails.DOB).format("MM-DD-YYYY")}</td>
                    </tr>
                </tbody>
            </table>
                <th>Driver License Details</th>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Jurisdiction</th>
                            <th scope="col">Driver License</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{testData.Response.DriverDetails[0].License.JurisdictionOfIssue}</td>
                            <td>{testData.Response.DriverDetails[0].License.LicenseNumber}</td>
                        </tr>
                    </tbody>
                </table>
                </> :
                <>
                <th>Minimal Search Results</th>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Seq ID</th>
                            <th scope="col">State</th>
                            <th scope="col">Driver License</th>
                            <th scope="col">First Name</th>
                            <th scope="col">Middle Name</th>
                            <th scope="col">Last Name</th>
                            <th scope="col">Date of Birth</th>
                        </tr>
                    </thead>
                    <tbody>
                        {newList.map((details, index) => (
                            <tr>
                                <td>{index+1}</td>
                                <td>{details.JurisdictionOfIssue}</td>
                                <td>
                                    <Link href="/historyresults" onClick={(e) => navHistory(e, details.LicenseNumber, details.JurisdictionOfIssue)}>{details.LicenseNumber}</Link>
                                </td>
                                <td>{details.FirstName}</td>
                                <td>{details.MiddleName}</td>
                                <td>{details.SurName}</td>
                                <td>{moment(details.DOB).format("MM-DD-YYYY")}</td>

                            </tr>
                        ))}
                    </tbody>
                </table>
                </>}
                </div>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
            <a href='/'><button type="button" class="btn btn-primary" id="button">Done</button></a>

         </div>
         </div></>
    );
}

export default MinimalResponse;